export const LEVEL_COLORS = {
  A: { solid: "#b45309", soft: "#fdf0dc", text: "#7c3d06" },
  B: { solid: "#1d4ed8", soft: "#e4ebfd", text: "#16359b" },
  C: { solid: "#047857", soft: "#dcf2ea", text: "#03593f" },
  D: { solid: "#6d28d9", soft: "#ece2fc", text: "#4f1d9e" },
  E: { solid: "#0e7490", soft: "#dceff6", text: "#0a5468" },
  F: { solid: "#be123c", soft: "#fce2e8", text: "#8a0d2c" },
  G: { solid: "#4338ca", soft: "#e5e4fb", text: "#302a94" },
  H: { solid: "#7c2d12", soft: "#f7e5dd", text: "#5b210d" },
};

export const LEVEL_FALLBACK_COLOR = { solid: "#334155", soft: "#e2e8f0", text: "#1e293b" };

export const LEVEL_ID_MAP = {
  8: "H",
  7: "G",
  1: "F",
  2: "E",
  3: "D",
  4: "C",
  5: "B",
  6: "A",
};

export const getLevelLetterFromId = (levelId) => LEVEL_ID_MAP[levelId] || "";

export const getLevelLettersFromIds = (levelIds) => {
  if (!Array.isArray(levelIds)) return [];
  return levelIds.map((id) => LEVEL_ID_MAP[id] || `ID ${id}`);
};

export const getLevelLetter = (value) => {
  const text = String(value ?? "").toUpperCase();
  if (!text) return "";
  const spaced = text.match(/\b([A-H])\b/);
  if (spaced) return spaced[1];
  const trailing = text.match(/([A-H])\s*$/);
  return trailing ? trailing[1] : "";
};

export const getLevelColor = (value) => {
  const letter = getLevelLetter(value);
  return LEVEL_COLORS[letter] || LEVEL_FALLBACK_COLOR;
};

export const getLevelModifierClass = (value) => {
  const letter = getLevelLetter(value);
  return letter ? `level-chip-${letter.toLowerCase()}` : "level-chip-default";
};

export const getLevelChipClass = (value, variant = "solid") => {
  const base = variant === "soft" ? "level-chip level-chip-soft" : "level-chip";
  return `${base} ${getLevelModifierClass(value)}`;
};

export const getLevelTextClass = (value) => `level-text ${getLevelModifierClass(value)}`;

export const getLevelTextStyle = (value) => ({ color: getLevelColor(value).text });
